import { memo, useEffect, useState } from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import { CRIcon, CRRender, Inline } from '../../crRender';
import { CheckArabicText, CheckEnglishText } from '@/utils';

const timeId = Date.now()

const Field = ({ label, value = "", lang = "Ar", setValue, type, disabled, className, isRequired = true, defaultValue = "", min, max, step, errorMessage }) => {

    const { t } = useTranslation()

    const [showPassword, setShowPassword] = useState(false)
    const [inputVal, setInputVal] = useState(defaultValue || "")

    useEffect(() => {
        setValue?.({ isRequired, value: defaultValue || value?.value || "", isError: false, type }, { markAsTouched: false })
        setInputVal(defaultValue)
    }, [disabled, isRequired, defaultValue, type])

    const handleChange = (target) => {
        const inptVal = type != 'file' ? target.value || "" : target.files
        if (lang == "Ar" || (inptVal == "" && lang != 'En') && type != 'file') {
            if (CheckArabicText(inptVal) || inptVal == "") {
                setValue?.({
                    isRequired,
                    value: inptVal?.trim(),
                    isError: false
                })
                setInputVal(inptVal)
            }
        }
        if (lang == "En" || (inptVal == "" && lang != 'Ar') && type != 'file') {
            if (CheckEnglishText(inptVal) || inptVal == "") {
                setValue?.({
                    isRequired,
                    value: inptVal?.trim(),
                    isError: false
                })
                setInputVal(inptVal)
            }
        }
        if (lang == "any") {
            setInputVal(inptVal)
            setValue?.({
                isRequired,
                value: inptVal?.trim(),
                isError: false
            })
        }
    }



    return (

        <div className={`form-group col-md-6  col-sm-12 ${className}`}>
            <CRRender isRender={label}>
               <div className="d-flex">
                 <label htmlFor={`${timeId}_${label}`}>{t(label)}</label>
                <Inline isRender={isRequired} className={"required"}>*</Inline>
               </div>
            </CRRender >


          <div className="relative-input">
              <input
                placeholder={`${t("please-enter")} ${t(label)}`}
                disabled={disabled}
                className={`form-control input  ${errorMessage ? "field-required" : ""}`}
                type={!showPassword ? type : 'text'}
                id={`${timeId}_${label}`}
                value={inputVal || value?.value || ""}
                autoComplete="one-time-code"
                min={min}
                max={max}
                step={step}
                onChange={(e) => handleChange(e.target)} />

            <CRIcon
                isRender={type == "password"}
                onClick={() => setShowPassword(prev => !prev)}
                icon={`${!showPassword ? "fluent:eye-32-filled" : "fluent:eye-off-32-filled"}`}
                className={'eye-sign'} />
                
          </div>
          <CRRender isRender={errorMessage} >
                        <p className="error-message">
                            {t(errorMessage)}
                        </p>
                </CRRender>
                
        </div>
    )
}
export default memo(Field);
